module.exports = __webpack_public_path__ + "img/Shinobi-Gaming-Logo-Template.jpg";